<script>
import { mapState, mapActions } from "vuex";
import ClientFactory from "@/api/ClientFactory";
import { VueGoodTable } from "vue-good-table";
const timekeepingApi = ClientFactory.get("timekeepings");
const departmentApi = ClientFactory.get("departments");
const dropdownsApi = ClientFactory.get("dropdowns");

export default {
  components: {
    VueGoodTable,
  },
  data: () => ({
    labelTypeSub:"Năm",
    valueTypeSub:"",
    dataTypeSub:[],
    class_visible:"invisible",
    valueDepartment: "0",
    dataDepartment: [],
    dataTK: [],
    valueMonth: new Date().getMonth()+1,
    valueYear: new Date().getFullYear(),
    valueTT: "4",
  }),
  computed: {
    ...mapState("auth", ["AppActiveUser"]),
    columns() {
      return [
        {
          label: "Họ và tên ",
          field: "full_name",
          thClass: "name-class text-center",
          tdClass: "name-class",
        },
        {
          label: "Số ngày công làm",
          field: "workday_real",
          thClass: "name-class text-center",
          tdClass: "name-class text-center",
        },

        {
          label: "Học đào tạo",
          field: "learn",
          thClass: "name-class text-center",
          tdClass: "name-class text-center",
          width:"150px"
        },
        {
          label: "Thai sản/dưỡng sức",
          field: "maternity",
          thClass: "name-class text-center",
          tdClass: "name-class text-center",
          width:"150px"
        },
        {
          label: "Số nghỉ phép",
          field: "leave",
          thClass: "name-class text-center",
          tdClass: "name-class text-center",
          width:"150px"
        },
        {
          label: "Số nghỉ Ốm/CÔ/Tai nạn/Khác",
          field: "sick",
          thClass: "name-class text-center",
          tdClass: "name-class text-center",
          width:"150px"
        },
        {
          label: "Nghỉ không lương",
          field: "unpaid_leave",
          thClass: "name-class text-center",
          tdClass: "name-class text-center",
          width:"150px"
        }
      ]
    },
    dataMonth() {
      return [
        {
          label: "Tháng 1",
          value: 1,
        },
        {
          label: "Tháng 2",
          value: 2,
        },
        {
          label: "Tháng 3",
          value: 3,
        },
        {
          label: "Tháng 4",
          value: 4,
        },
        {
          label: "Tháng 5",
          value: 5,
        },
        {
          label: "Tháng 6",
          value: 6,
        },
        {
          label: "Tháng 7",
          value: 7,
        },
        {
          label: "Tháng 8",
          value: 8,
        },
        {
          label: "Tháng 9",
          value: 9,
        },
        {
          label: "Tháng 10",
          value: 10,
        },
        {
          label: "Tháng 11",
          value: 11,
        },
        {
          label: "Tháng 12",
          value: 12,
        },
      ]
    },
    dataYear() {
      return [
        {
          label: new Date().getFullYear() + 1,
          value: new Date().getFullYear() + 1,
        },
        {
          label: new Date().getFullYear(),
          value: new Date().getFullYear(),
        },
        {
          label: new Date().getFullYear() - 1,
          value: new Date().getFullYear() - 1,
        },
        {
          label: new Date().getFullYear() - 2,
          value: new Date().getFullYear() - 2,
        },
      ]
    },
    dataTT() {
      return [
        {
          label: "Tháng",
          value: "1",
        },
        {
          label: "Quý",
          value: "2",
        },
        {
          label: "Nửa năm",
          value: "3",
        },
        {
          label: "Năm",
          value: "4",
        },
      ]
    },
    dataQuy() {
      return [
        {
          label: "Quý 1",
          value: "1",
        },
        {
          label: "Quý 2",
          value: "2",
        },
        {
          label: "Quý 3",
          value: "3",
        },
        {
          label: "Quý 4",
          value: "4",
        },
      ]
    },
    dataNuaNam() {
      return [
        {
          label: "6 tháng đầu năm",
          value: "1",
        },
        {
          label: "6 tháng cuối năm",
          value: "2",
        },
      ]
    }
  },
  async created() {
    if(this.CheckRole(8)=== false){
      this.GoPagesError();
    } else{
      const params = {
        department_type: 1,
      };

      const {data} = await departmentApi.get_department_byuser(params);
      this.dataDepartment = data.map(item=>{
        return{
          label:item.name,
          value:item.id
        }
      })
      this.valueDepartment= this.AppActiveUser.department_id;
      //this.dataDepartment = await dropdownsApi.get(dropdownsApi.type.DEPARTMENTS);
      this.searchTK();
    }
  },
  methods: {
    ...mapActions("ui", ["loading", "closeLoading", "notify"]),
    async MapSelect(data, label_data, value_data) {
      let result = [];
      let dt = {};
      dt.label ="Tất cả";
      dt.value = "0";
      result.push(dt);
      for (let index = 0; index < data.length; index++) {
        dt={};
        dt.label = data[index][label_data];
        dt.value = data[index][value_data];
        result.push(dt);
      }
      return result;
    },
    getChange(row){
      if(this.valueTT ==1){
        this.labelTypeSub = "Tháng";
        this.class_visible = "visible";
        this.dataTypeSub = this.dataMonth;
        this.valueTypeSub = "1";
      }else if(this.valueTT ==2){
        this.labelTypeSub = "Quý";
        this.valueTypeSub = "1";
        this.dataTypeSub = this.dataQuy;
        this.class_visible = "visible";
      }else if(this.valueTT ==3){
        this.labelTypeSub = "Nửa năm";
        this.valueTypeSub = "1";
        this.dataTypeSub = this.dataNuaNam;
        this.class_visible = "visible";
      }
      else{
        this.labelTypeSub = "Năm";

        this.class_visible = "invisible";
      }
    },
    searchTK: async function() {
      this.loading(this.$vs);
      const params = {
        year: this.valueYear,
        department_id: this.valueDepartment,
        sub_type: this.valueTypeSub,
        type: this.valueTT
      };

      const result = await timekeepingApi.statistical_timekeeping(params);

      this.checkResponseData(result);
      this.closeLoading();
    },
    checkResponseData: function(data) {
      if (data.status == "success") {
        this.dataTK = data.data;
      } else {
        this.dataTK = [];
      }
    },

    CheckRole(id){
      return this.AppActiveUser.role.includes(id);
    },

    GoPagesError() {
      this.notify({
        error: true,
        title: "Permission",
        text: "Bạn không có quyền truy cập trang này",
      });
      this.$router
        .push({
          path: "/pages/not-authorized",
        })
        .catch(() => {});
    },
    /**
     * Tải bản chấm công (excel)
     */
    downloadTimeSheet: async function() {
      this.loading(this.$vs);
      const params = {
        year: this.valueYear,
        department_id: this.valueDepartment,
        sub_type: this.valueTypeSub,
        type: this.valueTT
      };
    
      const response = await timekeepingApi.downloadReport(params);
      this.closeLoading();
      
      if(typeof response === 'undefined' || response.status === 'failed') {
          return this.notify({
              error: true,
              text: response.message || "Unknow error",
          })
      }

      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `timesheet_report_${+ new Date().getTime()}.xlsx`)
      link.click();
      window.URL.revokeObjectURL(url);
      
    }

  },
  destroyed() {
    this.closeLoading();
  },
};
</script>

<template>
  <div class="StatisticalTimekeeping">
    <CCard title="Tìm kiếm" class="mb-2">
      <CCardHeader class="pt-1 pb-1">
        <span class="card-header-title">Tổng hợp ngày công</span>
      </CCardHeader>
      <CCardBody class="pt-1 pb-1">
        <CRow>
          <CCol sm="3">
            <CSelect
              label="Đơn vị"
              :options="dataDepartment"
              :value.sync="valueDepartment"
              class=" pt-1"
            />
          </CCol>
          <CCol sm="3">
            <CSelect
              label="Năm"
              :options="dataYear"
              :value.sync="valueYear"
              class=" pt-1"
            />
          </CCol>
          <CCol sm="3">
            <CSelect
              label="Kỳ"
              :options="dataTT"
              :value.sync="valueTT"
              @change="getChange"
              class=" pt-1"
            />
          </CCol>
          <CCol sm="3">
            <CSelect
              :class="class_visible"
              :label="labelTypeSub"
              :options="dataTypeSub"
              :value.sync="valueTypeSub"
              class=" pt-1"
            />
          </CCol>
        </CRow>
        <CRow>
          <CCol sm="12" class="center" style="margin-top:10px">
            <vs-button
              warn
              square
              class="custom_btn_search "
              @click="searchTK()"
            >
              <i class="bx bx-search"></i>&nbsp;Tìm kiếm</vs-button
            >
          </CCol>
        </CRow>
      </CCardBody>
    </CCard>
    <CCard class="mb-2">
      <vue-good-table
        :columns="columns"
        :rows="dataTK"
        compactMode
        :group-options="{
          enabled: true
        }"
        :pagination-options="{
          enabled: true,
          perPage: 100,
          perPageDropdownEnabled: false,
          nextLabel: 'Trang sau',
          prevLabel: 'Trang trước',
          ofLabel: 'của',
        }"
        :search-options="{
          enabled: false,
          placeholder: 'Tìm kiếm',
        }"
        :sort-options="{
          enabled: false,
        }"
        :line-numbers="true"
      >
        <div slot="emptystate">
          Không có dữ liệu
        </div>
      </vue-good-table>
      <CRow>
          <CCol sm="12" class="center" style="margin-top:10px">
            <vs-button
              success
              square
              @click="downloadTimeSheet()"
            >
              <i class="bx bxs-download"></i>&nbsp;Tải về</vs-button
            >
          </CCol>
      </CRow>
    </CCard>
  </div>
</template>

<style lang="scss">
.DepartmentTimekeeping {
  table.vgt-table td {
    vertical-align: inherit;
  }
  .width-class {
    min-width: 1px !important;
  }
  .name-class {
    min-width: none;
    -width: 250px !important;
  }

  .month-class {
    min-width: none;
    -width: 80px !important;
  }
}
</style>
